module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sales/interests/interests-edit/interests-edit.component.css
// module id = ./src/app/components/sales/interests/interests-edit/interests-edit.component.css
// module chunks = main